import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import InstallerTableComponent from './../Components/InstallerTableComponent.jsx';
import { Button } from 'react-bootstrap';
import { getBuildPageInstallerFileDifferences } from './../reducers';
import { installerFiles as installerFileActions } from './../actions';

const BUTTON_COL_STYLE = { textAlign: 'center' };
export class InstallerTableContainer extends Component {
    static propTypes = {
      files: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        filename: PropTypes.string.isRequired,
        added: PropTypes.bool,
        expected: PropTypes.bool,
        selected: PropTypes.bool
      })).isRequired,
      hasSelectedFiles: PropTypes.bool,
      selectFile: PropTypes.func.isRequired,
      setExpected: PropTypes.func.isRequired,
      selectAll: PropTypes.func.isRequired,
      setSelectedAsExpected: PropTypes.func.isRequired,
      showExpected: PropTypes.bool
    };

    render() {
      const { files, selectFile, setExpected, showExpected } = this.props;
      const tableRows = [];
      if (files.length > 0 && files[0].id > 0) {
        tableRows.push(files.map((file, i) =>
        {
          if (file.id > 0 && file.expected === showExpected)
            return (
              <tr
                key={i}
                className={`${file.selected ? 'active' : ''}`}
              >
                <td id={'select-file-' + i} onClick={() => selectFile(file)}>
                  <input type="checkbox" checked={file.selected} />
                </td>
                <td onClick={() => selectFile(file)}>{file.filename}</td>
                <td onClick={() => selectFile(file)}>
                  { file.added ? 'Added' : 'Removed' }
                </td>
                <td onClick={() => selectFile(file)}>
                  {file.expected ? 'Expected' : 'Not Expected'}
                </td>
                <td style={BUTTON_COL_STYLE}>
                  <Button id={'expect-file-' + i} onClick={() => setExpected(file)}>
                    {file.expected ? 'Not Expected' : 'Expected'}
                  </Button>
                </td>
              </tr>
            );
        }
        ));
      } else {
        tableRows.push(
          <tr key={'Empty'}><td>No unexpected installer files</td></tr>
        );
      }
      return (
        <InstallerTableComponent
          tableRows={tableRows} secondColumnName={'Change'}
          dropDownColumn buttonColumn acknowledgeColumn={'Acknowledged?'}
          {...this.props}
        />
      );
    }
}

export const mapStateToProps = (state) => {
  const files = getBuildPageInstallerFileDifferences(state);
  return {
    files,
    hasSelectedFiles: files.find(f => f.selected === true) !== undefined
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    selectFile: file => dispatch(installerFileActions.changeInstallerFile({
      ...file,
      selected: !file.selected
    })),
    setExpected: file => dispatch(installerFileActions.changeInstallerFile({
      ...file,
      expected: !file.expected
    })),
    selectAll: (files, selected) =>
      dispatch(installerFileActions.selectAllInstallerFiles(files, selected)),
    setSelectedAsExpected: (files, expected) =>
      dispatch(installerFileActions.setSelectedInstallerFilesAsExpected(files, expected))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InstallerTableContainer);


// WEBPACK FOOTER //
// src/Containers/InstallerTableContainer.jsx